import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `QSocialNow | ${title}`;
  }, [title]);
};

export default useDocumentTitle;
